<div id="cover-landing" class="text-white  flex justify-center items-center">
  <div
    class="container flex flex-col lg:flex-row justify-center lg:justify-start items-center lg:items-start px-5 text-center lg:text-start pt-32 pb-[10rem]">

    <div class="contact lg:w-1/2 w-full">
      <h1 class="text-[#4B227A] font-bold xl:text-5xl lg:text-4xl md:text-3xl text-2xl leading-tight mb-5">
        Exam Questions To Build Your Confidence
      </h1>
      <p class="lg:text-lg text-[#2D2E32] leading-[1.8]  mx-auto lg:mx-0">
        From quick warm-ups to advanced challenges, our exam-style questions support IB, A
        Level, AS Level, IGCSE, GCSE, CBSE, and ICSE students. Each set is designed to
        sharpen understanding and reduce exam stress. With clear solutions and smart topic
        organisation, Exemplix helps you practise with purpose.
      </p>
      <div class="mb-12 md:mb-2 sm:mb-0 mt-5 flex lg:justify-start justify-center items-center">
        <!-- <app-main-btn
          [btnTxColor]="'white'"
          [borderColor]="'primary'"
          [btnColor]="'primary'"
          [btnName]="'Explore Exam Questions'" /> -->
      </div>
    </div>

    <div class="lg:w-1/2 mt-10 lg:mt-0 flex justify-center">
      <img src="Images/examstatic.png" alt="exam" class="w-[50%] max-w-sm lg:max-w-full" />
    </div>

  </div>
</div>